import { render, staticRenderFns } from "./StampEmptyImage.vue?vue&type=template&id=2af52472&scoped=true&"
import script from "./StampEmptyImage.vue?vue&type=script&lang=js&"
export * from "./StampEmptyImage.vue?vue&type=script&lang=js&"
import style0 from "./StampEmptyImage.vue?vue&type=style&index=0&id=2af52472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af52472",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2af52472')) {
      api.createRecord('2af52472', component.options)
    } else {
      api.reload('2af52472', component.options)
    }
    module.hot.accept("./StampEmptyImage.vue?vue&type=template&id=2af52472&scoped=true&", function () {
      api.rerender('2af52472', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/Stamp/components/StampEmptyImage.vue"
export default component.exports